import { Component, Input ,OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { LocationManagementComponent } from '../location-management/location-management.component';
import Swal from 'sweetalert2';
import { catchError, of } from 'rxjs';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { PermissionService } from 'src/app/services/permission.service';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-master-data',
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.css']
})
export class MasterDataComponent implements OnInit {
  @Input() public id!: string;
  Data: any[] = [];
  columns: any[] = []; 
  activeContent: string = '';
  pageIndex: number = 0;
  showNoRecordsFounds: boolean = true;
  isSearch: boolean = false;
  startsWith: string = '';
  pageSize: number = 10;
  paginationState: { [key: string]: { pageIndex: number, pageSize: number} } = {};
  buttons = [
    { id: 'Continent', label: 'Continent'},
    { id: 'Country', label: 'Country' },
    { id: 'State', label: 'States' },  
    { id: 'City', label: 'Cities' },
    {id:"Account Type",label:"Account Types"},
    {id:"Speciality",label:"Specialities"},
    {id: "Equipment", label:"Equipments"},
    {id: "Service", label: "Services"},
    {id:"Position",label:"Positions"},
    {id:"Lead Source",label:"Lead Sources"},
    {id:"Job Category",label:"Job Categories"},
    {id:"Job Skill",label:"Job Skills"},
    {id:"Job Type",label:"Job Types"},
    {id:"Experience Level",label:"Experience Level"},
    {id:"Degree Level",label:"Degree Level"},
    {id:"Job Tag",label:"Job Tags"},
    {id:"Tests",label:"Lab Tests"},
    {id:"Support Issue",label:"Support Issue Type"},
    {id:"Support Priority",label:"Support Priority"},
    {id:"Department",label:"Department"},
    {id:"Salary Range",label:"Salary Range"},
    {id:"incoterms",label:"Incoterms"},

  ];
  isDynemicPagination: boolean = true;
  accountTypeData: any [] = [];
  
  permissions=[];
  hasAddPermission:boolean=true;
  hasViewPermission:boolean=true;
  hasEditPermission:boolean=true;
  hasDeletePermission:boolean=true;
  isUpdatePermission:boolean=false;
  isLocationManagementPopupClose: boolean = false;
  totalEntries: number = 0; 
  isInitialLoad: boolean = true;

  constructor(public dialog: MatDialog, private masterDataService: MasterDataService, private endCustomer: EndCustomerService,private  spinnerService : SpinnerService , private breadCrumbService: BreadcrumbService,
    private permissionService: PermissionService,
        private localStorageService: LocalStorageService,
        private breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.showAllBreakPoints();
    if (this.buttons.length > 0) {
      this.activeContent = this.buttons[0].id;
    }
    this.restorePreviousData();
    this.restorePaginationState();

    this.breadCrumbService.setBreadcrumbs(['Dashboard' , this.activeContent]);
    if(this.localStorageService.getItem('preferences') &&this.localStorageService.getItem('preferences').length>0){
      this.isUpdatePermission = true;
      this.permissions=this.localStorageService.getItem('preferences')
      this.hasAddPermission=this.permissionService.hasPermission('MASTER_CREATE',this.permissions);
      this.hasViewPermission=this.permissionService.hasPermission('MASTER_VIEW',this.permissions);
      this.hasEditPermission=this.permissionService.hasPermission('MASTER_EDIT',this.permissions);
      this.hasDeletePermission=this.permissionService.hasPermission('MASTER_DELETE',this.permissions);
    }
    this.toggleContent(this.activeContent);
    this.isInitialLoad = false; 
  
  }

  restorePreviousData() {
    const savedActiveContent = sessionStorage.getItem('activeContent');
    this.activeContent = savedActiveContent && this.buttons.some(button => button.id === savedActiveContent)? savedActiveContent : this.buttons[0].id;

    const savedSearch:string|null = sessionStorage.getItem('startsWith');
    this.startsWith = savedSearch || '';
    this.isSearch = !!this.startsWith; 
  }
  applyFilter(event: any) {
    const searchTerm = event.target ? event.target.value.trim() : event.trim();
    this.isSearch = !!searchTerm;
    this.startsWith = searchTerm;
    this.pageIndex = 0;
    this.toggleContent(this.activeContent);
  }
  onPageChanged(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.savePaginationState();
    this.toggleContent(this.activeContent);
  }
  savePaginationState() {
    sessionStorage.setItem('masterPageIndex', this.pageIndex.toString());
    sessionStorage.setItem('masterPageSize', this.pageSize.toString());
  }

  restorePaginationState() {
    const savedPageIndex = sessionStorage.getItem('masterPageIndex');
    const savedPageSize = sessionStorage.getItem('masterPageSize');
    if (savedPageIndex) {
      this.pageIndex = parseInt(savedPageIndex, 10);
    }
    if (savedPageSize) {
      this.pageSize = parseInt(savedPageSize, 10);
    }
  }
  searchTermMethod(event: any) {
    const searchTerm = event.trim();
    this.isSearch = !!searchTerm;
    this.startsWith = searchTerm;
    this.pageIndex = 0;

    if (this.isSearch) {
      sessionStorage.setItem('startsWith', this.startsWith);
    } else {
      sessionStorage.removeItem('startsWith');
    }
    this.toggleContent(this.activeContent);
  }
  toggleContent(contentId: string) {

    if(this.activeContent!==contentId && !this.isInitialLoad){
      this.pageIndex = 0;
      this.startsWith = '';
      this.pageSize = 10; 
      this.isSearch = false;
      sessionStorage.removeItem('startsWith');
      sessionStorage.removeItem('masterPageIndex');
      sessionStorage.removeItem('masterPageSize');
    }
    this.isDynemicPagination = true;
    
    if (this.activeContent !== contentId) {
      this.activeContent = contentId;
      sessionStorage.setItem('activeContent', this.activeContent);
    }
    if (this.pageIndex !== 0 || this.pageSize !== 10) {
      sessionStorage.setItem('masterPageSize', this.pageSize.toString());
      sessionStorage.setItem('masterPageIndex', this.pageIndex.toString());
    }
    this.breadCrumbService.setBreadcrumbs(['Dashboard' , this.activeContent]);
    switch (this.activeContent) {
      case 'Continent':
        if(!this.isSearch){
                
        this.spinnerService.showSpinner();
      
        }
        this.masterDataService.getContinentsWithSearch(this.startsWith).subscribe(data => {
          this.totalEntries = data.totalCount ?? data.data?.length ?? 0;
          if(!this.isSearch){
            this.spinnerService.hideSpinner();
          }
          
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Continent Code', property: 'continentCode', visible: true, isModelProperty: true, isText: true },
             { name: 'Continent Name', property: 'continentName', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
            this.totalEntries = data.data.totalCount;
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Continent Code', property: 'continentCode', visible: true, isModelProperty: true, isText: true },
             { name: 'Continent Name', property: 'continentName', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
                 
               ]
             }
           ]);
           
          }
        });
        break;
      case 'Country':
         
      if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getCountries(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
          this.totalEntries = data.totalCount;
          if(!this.isSearch){
            this.spinnerService.hideSpinner();
          }
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
            { name: 'Country Name', property: 'countryName', visible: true, isModelProperty: true, isText: true },
            { name: 'Continent Code', property: 'continentCode', visible: true, isModelProperty: true, isText: true },
            { name: 'Country Code', property: 'countryCode', visible: true, isModelProperty: true, isText: true },
            { name: 'Phone Code', property: 'phoneCode', visible: true, isModelProperty: true, isText: true },
            { name: 'Currency Symbol', property: 'currencySymbol', visible: true, isModelProperty: true, isText: true },
            { name: 'Currency', property: 'currency', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'Country Name', property: 'countryName', visible: true, isModelProperty: true, isText: true },
              { name: 'Continent Code', property: 'continentCode', visible: true, isModelProperty: true, isText: true },
              { name: 'Country Code', property: 'countryCode', visible: true, isModelProperty: true, isText: true },
              { name: 'Phone Code', property: 'phoneCode', visible: true, isModelProperty: true, isText: true },
              { name: 'Currency Symbol', property: 'currencySymbol', visible: true, isModelProperty: true, isText: true },
              { name: 'Currency', property: 'currency', visible: true, isModelProperty: true, isText: true },
              {
                name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions: [
                  { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                  { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                  { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
                  
                ]
              },
            ]);
          }
        });
          
        break;
        case 'State':
                if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
          this.masterDataService.getStates(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
            this.totalEntries = data.totalCount;
            this.spinnerService.hideSpinner();
            if(this.isUpdatePermission){
              let columns=[
                { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
                { name: 'State Name', property: 'stateName', visible: true, isModelProperty: true, isText: true },
                { name: 'State Code', property: 'stateCode', visible: true, isModelProperty: true, isText: true },
                { name: 'Country Name', property: 'countryName', visible: true, isModelProperty: true, isText: true },
                { name: 'Country Code', property: 'countryCode', visible: true, isModelProperty: true, isText: true },
              ];
              let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                  actions:[]
                        };
                        if(this.hasViewPermission){
                          action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                        }
                        if(this.hasEditPermission){
                          action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                        }
                        if(this.hasDeletePermission){
                          action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                        }
                        columns.push(action);
              this.setData(data, columns);
            } else {
              this.setData(data, [
                { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
                { name: 'State Name', property: 'stateName', visible: true, isModelProperty: true, isText: true },
                { name: 'State Code', property: 'stateCode', visible: true, isModelProperty: true, isText: true },
                { name: 'Country Name', property: 'countryName', visible: true, isModelProperty: true, isText: true },
                { name: 'Country Code', property: 'countryCode', visible: true, isModelProperty: true, isText: true },
                {
                  name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                  actions: [
                    { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                    { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                    { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
                  ]
                },
              ]);
            }
          });
          
            
          break;
      case 'City':
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getCities(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
          this.totalEntries =data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'City Name', property: 'cityName', visible: true, isModelProperty: true, isText: true },
              { name: 'State Name', property: 'stateName', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'City Name', property: 'cityName', visible: true, isModelProperty: true, isText: true },
              { name: 'State Name', property: 'stateName', visible: true, isModelProperty: true, isText: true },
              {
                name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions: [
                  { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                  { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                  { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
                ]
              },
            ]);
          }
        });
         
       
        break;

    case 'Account Type':
      this.isDynemicPagination = false;
            if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
      this.masterDataService.getOnboardingAccountTypes(this.startsWith).subscribe(data => {
        this.totalEntries = data.totalCount;
        this.spinnerService.hideSpinner();
        if(this.isUpdatePermission){
          let columns=[
            { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
            { name: 'Account Type', property: 'accountType', visible: true, isModelProperty: true, isText: true },
            {name:'Account Category',property:'accountCategory',visible:true,isModelProperty:true,isText:true},
          ];
          let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
              actions:[]
                    };
                    if(this.hasViewPermission){
                      action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                    }
                    if(this.hasEditPermission){
                      action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                    }
                    if(this.hasDeletePermission){
                      action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                    }
                    columns.push(action);
          this.setData(data, columns);        
        } else {
          this.setData(data, [
            { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
            { name: 'Account Type', property: 'accountType', visible: true, isModelProperty: true, isText: true },
            {name:'Account Category',property:'accountCategory',visible:true,isModelProperty:true,isText:true},
            {
              name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
              actions: [
                { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
              ]
            },
          ]);
        }
        const totalPages = Math.ceil(data.totalCount / this.pageSize);
        if(this.pageIndex >= totalPages - 1){
          this.isDynemicPagination = false;
        }
      });
      
        
      break;
      case 'Speciality':
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getSpecialities(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
          this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
            { name: 'Speciality', property: 'specialty', visible: true, isModelProperty: true, isText: true },
            {name:'Account Type',property:'accountsTypes',visible:true,isModelProperty:true,isObject:true},
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'Speciality', property: 'specialty', visible: true, isModelProperty: true, isText: true },
              {name:'Account Type',property:'accountsTypes',visible:true,isModelProperty:true,isObject:true},
              {
                name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions: [
                  { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                  { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                  { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
                ]
              },
            ]);
          }
        });
         
          
        break;
      case 'Position':
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getPositions(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
          this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'Positions', property: 'position', visible: true, isModelProperty: true, isText: true },
              { name: 'Account Type', property: 'accountType', visible: true, isModelProperty: true, isObject: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Positions', property: 'position', visible: true, isModelProperty: true, isText: true },
             { name: 'Account Type', property: 'accountType', visible: true, isModelProperty: true, isObject: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }  
        });
        
          
        break;
      case 'Lead Source':
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getLeadSources(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
          this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
            { name: 'Source Name', property: 'sourceName', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Source Name', property: 'sourceName', visible: true, isModelProperty: true, isText: true },
            
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
          const totalPages = Math.ceil(data.totalCount / this.pageSize);
          if(this.pageIndex >= totalPages - 1){
            this.isDynemicPagination = false;
          }
        });
         
        
        break;
      case 'Job Category':
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getJobCategories(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
          this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
            { name: 'Category Name', property: 'categoryName', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Category Name', property: 'categoryName', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        });
         
        
        break;
      case 'Job Skill':
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getJobSkills(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
         this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
            { name: 'Job Skill', property: 'name', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction,hasCondition:true,conditionProperty:'active',conditionValue:true });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction,hasCondition:true,conditionProperty:'active',conditionValue:true });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Job Skill', property: 'name', visible: true, isModelProperty: true, isText: true }, 
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction,hasCondition:true,conditionProperty:'active',conditionValue:true },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction,hasCondition:true,conditionProperty:'active',conditionValue:true }
               ]
             },
           ]);
          }
          const totalPages = Math.ceil(data.totalCount / this.pageSize);
          if(this.pageIndex >= totalPages - 1){
            this.isDynemicPagination = false;
          }
        });
         
        
        break;
      case 'Job Type':
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getJobTypes(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
         this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Job Type', property: 'jobType', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Job Type', property: 'jobType', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        });
        
          
        break;
      case 'Experience Level':
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getCareerLevels(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
         this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Experience Level', property: 'experienceLevel', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Experience Level', property: 'experienceLevel', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        });
        
          
        break;
      case "Degree Level":
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getDegreeLevels(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
         this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
            { name: 'Degree Level', property: 'degreeLevel', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Degree Level', property: 'degreeLevel', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        })
         
        
        break;
      case "Job Tag":
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getJobTags(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
         this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'Job Tag', property: 'jobTags', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Job Tag', property: 'jobTags', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        })
         
        
        break;
        case "Equipment":
          if(!this.isSearch){
            this.spinnerService.showSpinner();
          }
          this.masterDataService.getEquipments(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
            this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'Equipment', property: 'name', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Equipment', property: 'name', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
          const totalPages = Math.ceil(data.totalCount / this.pageSize);
          if(this.pageIndex >= totalPages - 1){
            this.isDynemicPagination = false;
          }
        })
        
        
        break;
        case "Service":
          if(!this.isSearch){
            this.spinnerService.showSpinner();
          }
          this.masterDataService.getServices(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
            this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Service', property: 'name', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Service', property: 'name', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        })
        break;
        case "Tests":
              if(!this.isSearch){
        this.spinnerService.showSpinner();
      }
        this.masterDataService.getTests(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
          this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Tests', property: 'name', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Tests', property: 'name', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        },error => {
          this.spinnerService.hideSpinner();
          this.Data = [];
          this.totalEntries = this.Data.length;
        })
        break;

        case "Support Issue":
          if(!this.isSearch){
            this.spinnerService.showSpinner();
          }
          this.masterDataService.getSupportTicketsIssueRelated(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
          this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'Support Issue Type', property: 'name', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Support Issue Type', property: 'name', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        },error => {
          this.spinnerService.hideSpinner();
          this.Data = [];
          this.totalEntries = this.Data.length;
        })
        break;
        
        case "Support Priority":
          if(!this.isSearch){
            this.spinnerService.showSpinner();
          }
          this.masterDataService.getSupportTicketsPriority(this.pageIndex, this.pageSize,this.startsWith).subscribe(data => {
            this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Support Priority', property: 'levelName', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Support Priority', property: 'levelName', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        },error => {
          this.spinnerService.hideSpinner();
          this.Data = [];
          this.totalEntries = this.Data.length; 
        })
        break;

        case "Department":
          if(!this.isSearch){
            this.spinnerService.showSpinner();
            
          }
          this.isDynemicPagination = false;
          
          this.masterDataService.getDepartments(this.pageIndex, this.pageSize, this.startsWith).subscribe(data => {
            this.totalEntries = data.totalCount;  
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Department', property: 'name', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Department', property: 'name', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
          const totalPages = Math.ceil(data.totalCount / this.pageSize);
          if(this.pageIndex >= totalPages - 1){
            this.isDynemicPagination = false;
          }
        })
        break;

case 'incoterms':
  if (!this.isSearch) {
    this.spinnerService.showSpinner();
  }
  this.masterDataService.getIncoterms(this.pageIndex, this.pageSize, this.startsWith).subscribe(data => {
    this.totalEntries = data.totalCount;
    this.spinnerService.hideSpinner();
    if (this.isUpdatePermission) {
    let columns = [
      { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
      { name: 'Name', property: 'name', visible: true, isModelProperty: true, isText: true },
      { name: 'Fields', property: 'fields', visible: true, isModelProperty: true, isFieldsArray: true }
    ];
     let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
                      if(columns.some((column: any) => column.property === 'fields')){
                        this.setData(data.data.map((incoterm: any) => incoterm.fields.map((field: any) => field.label).join(', ')), columns);
                      }
                      if(columns.some((column: any) => column.isArray)){
                        this.setData(data.data.map((incoterm: any) => incoterm.fields.map((field: any) => field.label).join(', ')), columns);
                      }
                      this.setData(data, columns);   
    } 
    else {
      this.setData(data, [
        { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
        { name: 'Name', property: 'name', visible: true, isModelProperty: true, isText: true },
        { name: 'Fields', property: 'fields', visible: true, isModelProperty: true, isFieldsArray: true,},
        {
          name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
          actions: [
            { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
            { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
            { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
          ]
        },
      ])
    }
     const totalPages = Math.ceil(data.totalCount / this.pageSize);
          if(this.pageIndex >= totalPages - 1){
            this.isDynemicPagination = false;
          }
  });
        break;
        
        case "Salary Range":
          if(!this.isSearch){
            this.spinnerService.showSpinner();
          }
          this.masterDataService.getSalaryRanges(this.pageIndex, this.pageSize, this.startsWith).subscribe(data => {
            this.totalEntries = data.totalCount;
          this.spinnerService.hideSpinner();
          if(this.isUpdatePermission){
            let columns=[
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
              { name: 'Salary Range', property: 'salaryRange', visible: true, isModelProperty: true, isText: true },
            ];
            let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
                actions:[]
                      };
                      if(this.hasViewPermission){
                        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
                      }
                      if(this.hasEditPermission){
                        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
                      }
                      if(this.hasDeletePermission){
                        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
                      }
                      columns.push(action);
            this.setData(data, columns);
          } else {
            this.setData(data, [
              { name: 'Sr. No', property: 'sNo', visible: true, isModelProperty: false, isText: true },
             { name: 'Salary Range', property: 'salaryRange', visible: true, isModelProperty: true, isText: true },
             {
               name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
               actions: [
                 { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
                 { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
                 { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
               ]
             },
           ]);
          }
        },error => {
          this.spinnerService.hideSpinner();
          this.Data = [];
          this.totalEntries = this.Data.length; 
        })
        break;
        default:
        break;
    }
  }
  
  private setData(data: any, columns: any[]): void {
    
    this.Data = data.data;
    if(this.Data &&this.Data.length==0){
      this.showNoRecordsFounds=true;
    }
    else if(!this.Data||this.Data.length==0){
      this.showNoRecordsFounds=false;
      this.Data = [];
      this.totalEntries = this.Data.length; 
    }
    this.columns = columns;
  }
  
openAddLocation() {
    const dialogRef = this.dialog.open(LocationManagementComponent, {
      width: '20%',
      data: {
        type: this.activeContent,
        headings: this.columns
          .filter(column => !column.hasAction && column.property !== 'sNo' && column.property !== 'fields')
          .map(column => ({ name: column.name, property: column.property }))
      },
      disableClose: (this.isLocationManagementPopupClose)? this.isLocationManagementPopupClose : false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toggleContent(this.activeContent);
      }
    });
  }
  openEditLocation(rowData: any) {
    const dialogRef = this.dialog.open(LocationManagementComponent, {
      width: '20%',
      data: {
        type: this.activeContent,
        headings: this.columns
          .filter(column => !column.hasAction && column.property !== 'sNo'  && column.property !== 'fields')
          .map(column => ({ name: column.name, property: column.property })),
        rowData: rowData
      },
      disableClose: (this.isLocationManagementPopupClose)? this.isLocationManagementPopupClose : false
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toggleContent(this.activeContent);
      }
    });
  }
  
  openViewLocation(rowData: any) {
    const dialogRef = this.dialog.open(LocationManagementComponent, {
      width: '20%',
      data: {
        type: this.activeContent,
        headings: this.columns
          .filter(column => !column.hasAction && column.property !== 'sNo'  && column.property !== 'fields')
          .map(column => ({ name: column.name, property: column.property })),
        rowData: rowData,
        viewMode: true 
      },
      disableClose: (this.isLocationManagementPopupClose)? this.isLocationManagementPopupClose : false
    }); 
  }
  deleteItem(id: string) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.masterDataService.deleteItem(this.activeContent, id).pipe(
          catchError(err => {
            Swal.fire(
              'Error!',
              'An error occurred while deleting the item.',
              'error'
            );
            return of(null);
          })
        ).subscribe(() => {
          Swal.fire(
            'Deleted!',
            'Item has been deleted.',
            'success'
          );
          // if(this.activeContent=="Account Type"){
          //   this.pageIndex = 0;
          // }
          
          this.toggleContent(this.activeContent);
        });
        
      }
    });
  }

  selectedAction(event:any) {
    switch (event.action) {
      case MweConstants.addAction:
        this.openAddLocation();
        break;
      case MweConstants.editAction:
        this.openEditLocation(event.row);
        break;
      case MweConstants.deleteAction:
        this.deleteItem(event.row.id);
        break;
      case MweConstants.viewAction:
        this.openViewLocation(event.row);
        break;
    
      default:
        break;
    }
  }

  showAllBreakPoints() {
    this.breakpointObserver.observe([
      "(min-width: 1190px) and (max-width: 1390px)",
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints["(min-width: 1190px) and (max-width: 1390px)"]) {
          this.isLocationManagementPopupClose = true;
        }
      } else{
        this.isLocationManagementPopupClose = false;
      }
    });
  }
}
